import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
import { CTAButton } from './CTAButton';
import { forYouItems } from '../data/content';
export function ForYouSection() {
  return <section className="border-t border-white/5 bg-void-900 py-24 md:py-32" data-id="element-90" data-mp="2cwawzrlgqm3b">
      <div className="mx-auto max-w-5xl px-6" data-id="element-91" data-mp="2hsszektbm8ch">
        <Reveal className="max-w-2xl" data-id="element-92" data-mp="1l3bjld0mj5x2">
          <SectionLabel data-id="element-93" data-mp="1l4d7ii2qnmw7">Para ti</SectionLabel>
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-5xl" data-id="element-94" data-mp="1l5egmh071zba">
            Este libro es para ti si…
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-x-10 gap-y-5 sm:grid-cols-2" data-id="element-95" data-mp="1u5t7rwzua8mp">
          {forYouItems.map((item, i) => <li key={item} data-id="element-96" data-mp="1z0go38kovwq7" data-mpi={i}>
              <Reveal delay={i % 2 * 0.05} className="h-full" data-id="element-97" data-mp="35jewjh1se87p">
                <div className="flex h-full items-start gap-4 rounded-sm border border-gold-500/15 bg-void-950/60 p-5 transition-shadow duration-300 hover:shadow-neon" data-id="element-98" data-mp="35l9gas1bnua7">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500 drop-shadow-[0_0_8px_rgba(34,227,127,0.7)]" aria-hidden="true" data-id="element-99" data-mp="5lf86jy6eew6" />
                  <p className="text-sm leading-relaxed text-bone-100 sm:text-base" data-id="element-100" data-mp="3sp3jckq2s4sy">{item}</p>
                </div>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.1} data-id="element-101" data-mp="3itil8xo4nooh">
          <div className="mt-12 flex justify-center" data-id="element-102" data-mp="3its3u06uetk5">
            <CTAButton label="Iniciar mi despertar" data-id="element-103" data-mp="3e1ifuppag3ki" />
          </div>
        </Reveal>
      </div>
    </section>;
}